import * as React from 'react';
import { Create, CreateProps, NumberInput, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { CustomFileInput } from '../components/CustomFileInput';
import { ETrainingType } from '../enums';

export const TrainingMenuCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<TextInput step={1} source="note" label="NOTE"/>
				<CustomFileInput step={1} source="menuUrl" label="MENU_FILE"/>
				<SelectInput step={1} source="type" label="TYPE" choices={Object.keys(ETrainingType).map(key => ({
					id: key,
					name: ETrainingType[key]
				}))}/>
				<NumberInput step={1} source="fromBMR" label="FROM_BMR"/>
				<NumberInput step={1} source="toBMR" label="TO_BMR"/>
			</SimpleForm>
		</Create>
	);
};
